export default __webpack_public_path__ + "static/media/green.59daa30c.png";